import React from 'react';
import { Modal } from 'reactstrap';

// Action Types
const OPEN_DIALOG = '@@redux-reactstrap-modal/OPEN_DIALOG';
const CLOSE_DIALOG = '@@redux-reactstrap-modal/CLOSE_DIALOG';

// Action Creators
export const openDialog = (name, data = {}) => ({
  type: OPEN_DIALOG,
  payload: { name, data }
});

export const closeDialog = (name) => ({
  type: CLOSE_DIALOG,
  payload: { name }
});

// Reducer
const initialState = {};

export const dialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        [action.payload.name]: {
          isOpen: true,
          data: action.payload.data
        }
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        [action.payload.name]: {
          isOpen: false,
          data: {}
        }
      };
    default:
      return state;
  }
};

// Higher Order Component
const reduxDialog = (connect, options = {}) => (WrappedComponent) => {
  const { name, backdrop, centered, className } = options;

  const mapStateToProps = (state) => ({
    isOpen: state.dialogReducer && state.dialogReducer[name] ? state.dialogReducer[name].isOpen : false,
    data: state.dialogReducer && state.dialogReducer[name] ? state.dialogReducer[name].data : {}
  });

  class DialogWrapper extends React.Component {
    render() {
      const { isOpen, data, ...rest } = this.props;

      return (
        <Modal
          isOpen={isOpen}
          backdrop={backdrop}
          centered={centered}
          className={className}
        >
          <WrappedComponent {...rest} data={data} />
        </Modal>
      );
    }
  }

  return connect(mapStateToProps)(DialogWrapper);
};

export default reduxDialog;
